export default {"src":"/_next/static/media/OP.2524b397.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};